<template>
  <div class="department">
    <div class="department-title">
      <el-button type="primary" @click="addPark('validateForm')"
        >新增</el-button
      >
    </div>
    <el-table
      :data="tableData"
      height="500"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column
        align="center"
        type="index"
        width="80"
        label="序号"
      ></el-table-column>
      <el-table-column
        align="center"
        label="科室名称"
        prop="name"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="center"
        label="科室地址"
        prop="address"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="center"
        label="联系人"
        prop="clerkName"
      ></el-table-column>
      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="editPark(scope.row)">编辑</el-button>
          <el-popconfirm
            title="您确定要删除这条科室信息吗？"
            confirm-button-text="继续"
            icon="el-icon-info"
            @confirm="deleteData(scope.row.id)"
          >
            <span
              style="color:#f00;cursor: pointer;margin-left:10px;"
              slot="reference"
              class="btn btn-delete"
              >删除</span
            >
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div class="department-footer">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="questionnaire.pageNum"
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog :title="titleName" :visible.sync="dialogVisible" width="25%">
      <el-form
        :model="validateForm"
        ref="validateForm"
        label-width="110px"
        class="demo-ruleForm"
        :rules="rules"
      >
        <el-form-item label="科室名称：" prop="name">
          <el-input
            type="text"
            v-model="validateForm.name"
            placeholder="请输入科室名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="科室地址：" prop="address">
          <el-input
            type="text"
            v-model="validateForm.address"
            placeholder="请输入科室地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="职能说明" prop="function">
          <el-input
            v-model="validateForm.function"
            type="textarea"
            maxlength="500"
            placeholder="请输入职能说明"
            show-word-limit
            :rows="10"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="科室联系方式" prop="tel">
          <el-input
            type="text"
            v-model="validateForm.tel"
            placeholder="请输入科室联系方式"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人姓名">
          <el-input
            type="text"
            v-model="validateForm.clerkName"
            placeholder="请输入联系人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人联系方式" prop="clerkTel">
          <el-input
            type="text"
            v-model="validateForm.clerkTel"
            placeholder="请输入联系人联系方式"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm('validateForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('validateForm')"
            >确认</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  listClerk,
  saveOrUpdateClerk,
  delDepart
} from '@/common/api/corporateInteraction/enterpriseGov'
import { isTel, noBlank } from '@utils'
export default {
  props: ['information'],
  data() {
    const checkPhone = (rule, value, callback) => {
      if (value) {
        // 判断当输入的有值时，才校验
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error('手机号格式不正确'))
        } else {
          callback() // 注意这里要回调一下，不然提交不了
        }
      } else {
        callback()
      }
    }
    return {
      titleName: '科室新增',
      dialogVisible: false,
      questionnaire: {
        pageNum: 1,
        pageSize: 10
      },
      validateForm: {
        departId: '',
        parentId: '',
        name: '',
        function: '',
        tel: '',
        clerkName: '',
        clerkTel: '',
        address: ''
      },
      rules: {
        name: [{ required: true, message: '请输入科室名称' }, noBlank()],
        address: [{ required: true, message: '请输入科室地址' }, noBlank()],
        function: [{ required: true, message: '请输入职能说明' }, noBlank()],
        tel: [{ required: true, message: '请输入科室联系方式' }, isTel()],
        clerkTel: [{ required: false, validator: checkPhone, trigger: 'blur' }]
      },
      total: 1,
      tableData: []
    }
  },
  watch: {
    information(val) {
      this.getList()
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    deleteData(id) {
      delDepart({ departId: id }).then(res => {
        this.$message({
          message: res.data.msg,
          type: 'success'
        })
        this.deleVisible = false
        this.getList()
        this.$emit('onGetList')
      })
    },
    getList() {
      const params = {
        parentId: this.information.id,
        pageNum: this.questionnaire.pageNum,
        pageSize: this.questionnaire.pageSize
      }
      listClerk(params).then(res => {
        const { results, totalRecord } = res.data.data
        this.tableData = results || []
        this.total = totalRecord
      })
    },
    // 编辑
    editPark(row) {
      this.dialogVisible = true
      this.titleName = '科室编辑'
      const { parentId, name, tel, clerkName, clerkTel, address } = row
      this.validateForm = {
        parentId,
        name,
        tel,
        clerkName,
        clerkTel,
        function: row.function,
        address
      }
      // this.validateForm.parentId = row.parentId
      this.validateForm.departId = row.id
      // this.validateForm.function = ''
      // this.validateForm.function = row.function
    },
    // 表格
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // this.validateForm.departId = this.information.id
          this.validateForm.parentId = this.information.id
          saveOrUpdateClerk({ ...this.validateForm }).then(res => {
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.dialogVisible = false
            this.$refs[formName].resetFields()
            this.validateForm.clerkName = ''
            this.validateForm.clerkTel = ''
            this.getList()
            this.$emit('onGetList')
          })
        } else {
          return false
        }
      })
    },
    addPark(formName) {
      this.validateForm = {
        departId: '',
        parentId: '',
        name: '',
        function: '',
        tel: '',
        clerkName: '',
        clerkTel: ''
      }
      this.dialogVisible = true
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.dialogVisible = false
    },
    // 分页
    handleSizeChange(val) {
      this.questionnaire.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.questionnaire.pageNum = val
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.department {
  padding: 20px 30px;
  &-title {
    text-align: right;
    margin-bottom: 20px;
  }
  &-footer {
    text-align: center;
    margin: 20px;
  }
}
/deep/.el-input__count {
  bottom: 1px;
  right: 30px;
}
</style>
